module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/all-good-e72823ed48a91adf28d02bc842059ce6.png";